module.exports = __webpack_public_path__ + "static/media/del.c6769e54.mp3";